import { stats } from '@/mocks/stats';
import { testimonials } from '@/mocks/testimonials';
import { useState, useEffect } from 'react';

export default function StatsSection() {
  const [activeTestimonial, setActiveTestimonial] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="py-14 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 mb-14">
          {stats.map((stat) => (
            <div key={stat.id} className="text-center">
              <div className="font-heading font-bold text-2xl md:text-4xl text-primary-600 mb-2">
                {stat.value}
                {stat.suffix && (
                  <span className="text-base md:text-lg text-foreground-400">{stat.suffix}</span>
                )}
              </div>
              <p className="text-xs md:text-sm text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>

        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-4">
            客户口碑
          </span>
          <div className="relative min-h-[140px] md:min-h-[120px]">
            {testimonials.map((t, idx) => (
              <div
                key={t.id}
                className={`transition-all duration-500 absolute inset-0 ${
                  idx === activeTestimonial ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
                }`}
              >
                <blockquote className="text-sm md:text-base text-foreground-700 leading-relaxed italic mb-4">
                  &ldquo;{t.content}&rdquo;
                </blockquote>
                <div>
                  <strong className="text-sm text-foreground-900 font-medium">{t.author}</strong>
                  <span className="text-foreground-400 mx-2">·</span>
                  <span className="text-xs text-foreground-500">{t.role}，{t.company}</span>
                </div>
              </div>
            ))}
          </div>
          <div className="flex items-center justify-center gap-2 mt-6">
            {testimonials.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setActiveTestimonial(idx)}
                className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                  idx === activeTestimonial ? 'bg-primary-500 w-6' : 'bg-foreground-300 hover:bg-foreground-400'
                }`}
                aria-label={`查看第${idx + 1}条评价`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}